import { render, staticRenderFns } from "./liCreateOrderV2.vue?vue&type=template&id=890239bc&scoped=true"
import script from "./liCreateOrderV2.vue?vue&type=script&lang=js"
export * from "./liCreateOrderV2.vue?vue&type=script&lang=js"
import style0 from "./liCreateOrderV2.vue?vue&type=style&index=0&id=890239bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "890239bc",
  null
  
)

export default component.exports